import AsianArt from '../../images/clients/asian-art-platform-logo 1.png';
import aws from '../../images/clients/aws-logo 1.png';
import bandai from '../../images/clients/bandai-namco 1.png';
import canon from '../../images/clients/canon-logo 1.png';
import columbia from '../../images/clients/columbia_threadneedle_investments 1.png';
import digipen from '../../images/clients/digipen-logo 1.png';
import lefistyle from '../../images/clients/eightx-lifestyle 1.png';
import village from '../../images/clients/enabling-village 1.png';
import ica from '../../images/clients/ica-logo 1.png';
import jaeger from '../../images/clients/jaegar-lecoultre-logo_ 1.png';
import monetary from '../../images/clients/mas-logo 1.png';
import ministry from '../../images/clients/ministry-of-education 1.png';
import ncs from '../../images/clients/ncs_logo 1.png';
import nationalUniversity from '../../images/clients/nuh-logo 1.png';
import patek from '../../images/clients/patek-philippe 1.png';
import sg from '../../images/clients/sg-enable-logo 1.png';
import sleek from '../../images/clients/sleek-logo 1.png';
import trump from '../../images/clients/trump-hotels-logo-vector 1.png';
import zairyo from '../../images/clients/zairyo 1.png';
import spacelogic from '../../images/clients/space-logic 1.png';

export const galleryClients = [
    {
        id: 1,src: AsianArt, alt: 'Asian Art logo',
    },
    {
        id: 2,src: aws, alt: 'aws logo',  
    },
    {
        id: 3,src: bandai, alt: 'bandai logo',      
    },
    {
        id: 4,src: canon, alt: 'canon logo',       
    },
    {
        id: 5,src: columbia, alt: 'columbia logo',       
    },
    {
        id: 6,src: digipen, alt: 'digipen logo',      
    },
    {
        id: 7,src: lefistyle, alt: 'lefistyle logo',        
    },
    {
        id: 8,src: village, alt: 'village logo',        
    },
    {
        id: 9,src: ica, alt: 'ica logo',     
    },
    {
        id: 10,src: jaeger , alt: 'jaeger logo',
    },
    {
        id: 11,src: monetary, alt: 'monetary logo',
    },
    {
        id: 12,src: ministry, alt: 'ministry logo',      
    },
    {
        id: 13,src: ncs, alt: 'ncs logo',      
    },
    {
        id: 14,src: nationalUniversity, alt: 'nationalUniversity logo',       
    },
    {
        id: 15,src: patek, alt: 'patek logo',       
    },
    {
        id: 16,src: sg, alt: 'sg logo',      
    },
    {
        id: 17,src: sleek , alt: 'sleek  logo',       
    },
    {
        id: 18,src: trump, alt: 'trump logo',       
    },
    {
        id: 19,src: zairyo, alt: 'zairyo logo',        
    },
    {
        id: 20,src: spacelogic, alt: 'spacelogic logo',       
    },
];


// WEBPACK FOOTER //
// ./src/page/about-us/gallery-clients.js